var CreditScoreBenefits = [
    {
        id: 1,
        imageUrl: "person_check.png",
        transKey: "noCreditScorePage.bodySection.benefits.transUnion",
    },
    {
        id: 2,
        imageUrl: "person_exclamation.png",
        transKey: "noCreditScorePage.bodySection.benefits.influences",
    },
    {
        id: 3,
        imageUrl: "hand_watch.png",
        transKey: "noCreditScorePage.bodySection.benefits.trackCreditScore",
    },
    {
        id: 4,
        imageUrl: "person_interrogation.png",
        transKey: "noCreditScorePage.bodySection.benefits.improveCreditScore",
    },
];
export default CreditScoreBenefits;
